import { createSlice, createAction, type PayloadAction } from '@reduxjs/toolkit'
import type {
    Station,
    StationCleanupJob,
    StationCleanupJobWithStation,
} from 'src/api/fm/stationCleanupJob/stationCleanupJob.model'
import { type AppState } from 'src/redux/app/app.store'

interface StationCleanupJobState {
    stationCleanupJobs: StationCleanupJobWithStation[]
    stations: Station[]
}

export const initialState: StationCleanupJobState = {
    stationCleanupJobs: [],
    stations: [],
}

const stationCleanupJobSlice = createSlice({
    name: 'stationCleanupJob',
    initialState,
    reducers: {
        setStationCleanupJobs(state, action: PayloadAction<StationCleanupJobWithStation[]>) {
            return {
                ...state,
                stationCleanupJobs: action.payload,
            }
        },
        setStations(state, action: PayloadAction<Station[]>) {
            return {
                ...state,
                stations: action.payload,
            }
        },
    },
})

// Actions
export const { setStationCleanupJobs, setStations } = stationCleanupJobSlice.actions
export const createStationCleanupJobs = createAction<{
    zoneId: string
    stationIds: string[]
    stationCleanupJob: StationCleanupJob
}>(`${stationCleanupJobSlice.name}/createStationCleanupJobs`)
export const updateStationCleanupJobs = createAction<{
    zoneId: string
    ids: string[]
    stationCleanupJob: StationCleanupJob
}>(`${stationCleanupJobSlice.name}/updateStationCleanupJobs`)
export const deleteStationCleanupJobs = createAction<{ zoneId: string; ids: string[] }>(
    `${stationCleanupJobSlice.name}/deleteStationCleanupJobs`,
)
export const getStationCleanupJobs = createAction<string>(`${stationCleanupJobSlice.name}/getStationCleanupJobs`)
export const getStations = createAction<{ zoneId: string; stationIds: string[] }>(
    `${stationCleanupJobSlice.name}/getStations`,
)

// Selectors
export const selectStationCleanupJobs = (state: AppState): StationCleanupJobWithStation[] =>
    state.stationCleanupJob.stationCleanupJobs
export const selectStations = (state: AppState): Station[] => state.stationCleanupJob.stations

// Reducer
export const { reducer: stationCleanupJobReducer } = stationCleanupJobSlice
